import React from 'react'
import {tagToUrl} from 'src/shared/utils'

import {classes} from './Status.classes'

type Props = {
  imageTag: string
}

const CustomIcon: React.FC<Props> = ({imageTag}) => {
  return <img alt="" className={classes.image} loading="lazy" src={tagToUrl(imageTag)} />
}

export default CustomIcon
